<template lang="pug">
	.sizes-switcher
		.sizes-control
			.control-button(v-for="group in sizeGroups" @click="selectGroup(group)" v-b-tooltip.hover="{delay: { show: 0, hide: 100 }, html: true}" :title="getGroupTitle(group)")
				.size-icon(:class="{selected: isGroupSelected(group)}" :style="getSizeStyle(getGroupSize(group))")
			.control-button.edit-button(@click="editSizes")
				.edit-icon.fa.fa-ellipsis-h

</template>

<script>
	import Screen 						from './../../mixins/screen';

	import { Creative }					from '../../services/Creative'
	import { Version }					from '../../services/Version'
	import { Layout }					from '../../services/Layout'

	export default {
		name: "SizesSwitcher",
		mixins: [Screen],
		props: ['type'],
		screen: {
			updateOn: [
				"Selected Version Changed: [options.sizes]",
				"Preview Size Changed"
			],
			events: {
				"Selected Creative Changed,Selected Creative Fully Loaded,Selected Version Switched": function() {

					if (Creative.isSelectedCreativeLoaded() && Version.SelectedVersion) this.update();

				}
			}
		},
		components: {
		},
		data() {

			this.sizeGroups = [];
			this.Layout = Layout;

			return {
				showed: true
			};

		},
		methods: {
			getType() {

				return this.type || Creative.SelectedCreative?.type || 'banner';

			},
			collectData() {

				let sizes = Version.SelectedVersion?.options?.sizes || [];

				// Парные размеры (портрет / ландшафт одного options.group из metadata_sizes) объединяются в одну кнопку
				this.sizeGroups = [];

				_.each(sizes, size => {

					let groupCodename = this.getSizeGroupCodename(size);
					let group = groupCodename ? _.find(this.sizeGroups, {codename: groupCodename}) : null;

					if (group) group.sizes.push(size);
					else this.sizeGroups.push({codename: groupCodename, sizes: [size]});

				});

			},
			// Группа размера из метаданных (общая у портретной и ландшафтной ориентаций)
			getSizeGroupCodename(size) {

				let type = this.getType();
				let sizeProps = _.find(Metadata.Sizes, o => o.type === type && o.width === size.width && o.height === size.height);

				return sizeProps?.options?.group || null;

			},
			// Размер группы, выбранный в превью, либо первый размер группы
			getGroupSize(group) {

				return this.getSelectedGroupSize(group) || group.sizes[0];

			},
			getSelectedGroupSize(group) {

				let previewSizeKey = Layout.getPreviewSizeKey();

				return _.find(group.sizes, size => `${size.width}x${size.height}` === previewSizeKey) || null;

			},
			isGroupSelected(group) {

				return !!this.getSelectedGroupSize(group);

			},
			getGroupTitle(group) {

				let size = this.getGroupSize(group);

				return (size.title ? (size.title + '<br>') : '') + size.width + ' x ' + size.height + (group.sizes.length > 1 ? '<br>Click again to switch orientation' : '');

			},
			// Клик по невыбранной кнопке выбирает размер группы, повторный клик переворачивает размер (портрет / ландшафт)
			selectGroup(group) {

				let selectedSize = this.getSelectedGroupSize(group);

				if (selectedSize && group.sizes.length > 1) {

					let sizeIndex = group.sizes.indexOf(selectedSize);

					Layout.setPreviewSize(group.sizes[(sizeIndex + 1) % group.sizes.length]);

				} else {

					Layout.setPreviewSize(group.sizes[0]);

				}

			},
			getSizeStyle(size) {

				let maxDimension = Math.max(size.width, size.height),
					scale = 30 / maxDimension;

				return {
					width: `${size.width * scale}px`,
					height: `${size.height * scale}px`,
				}

			},
			editSizes() {

				Broadcast.call("Show SizesEdit", [this.getType()]);

			}
		}
	}
</script>

<style lang="sass">

	.sizes-switcher
		display: flex
		align-items: center
		justify-content: center
		height: 46px
		z-index: 2
		transition: width 0.2s ease-in-out

		.sizes-control
			display: flex
			flex-direction: row
			margin-top: -1px
			margin-right: 130px

			.control-button
				display: flex
				align-items: center
				justify-content: center
				cursor: pointer
				margin: 0 5px 0 5px
				width: 30px
				height: 30px
				color: #000
				text-align: center
				font-size: 12px
				line-height: 20px

				.size-icon
					display: flex
					align-items: center
					justify-content: center
					height: 30px
					width: 30px
					border: 1px solid rgba(0,0,0,0.3)
					border-radius: 5px
					background: rgba(255,255,255,0.1)

					&.selected
						border: 1px solid #20a8d8

				.edit-icon
					display: flex
					align-items: center
					justify-content: center
					height: 30px
					width: 20px
					color: rgba(255,255,255,0.3)

					&:hover
						color: rgba(255,255,255,0.5)

			.control-button:hover

				.size-icon
					background: rgba(255,255,255,0.2)

			.control-button.edit-button
				width: 20px

</style>
